var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-expansion-panels',{staticClass:"rounded-0",attrs:{"flat":"","accordion":"","value":_vm.value},on:{"change":function($event){return _vm.updateValue($event)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }